module.exports = __webpack_public_path__ + "img/radisson-blu-hotel-lisbon.50634b8c.jpg";